import * as React from "react"
import { Text } from "gatsby-interface"
import { Stepper, Step } from "@modules/site/create/shared/components/Stepper"
import { cardInfoCss } from "@modules/site/create/Provision/components/StarterCard"
import { siteTypeIcons, cmsVendorIcons } from "@modules/site/create/icons"

type ProvisionConfigurationAsideProps = {
  currentStep: number
  starterImageUrl: string
  starterTitle: string
  starterCmsTemplateId: string
  starterVendor?: string
  className?: string
  stepLabels?: string[]
}

export function ProvisionConfigurationAside({
  currentStep,
  starterImageUrl,
  starterTitle,
  starterCmsTemplateId,
  starterVendor,
  className,
  stepLabels = [],
}: ProvisionConfigurationAsideProps) {
  const Icon = starterVendor
    ? cmsVendorIcons[starterVendor]
    : starterCmsTemplateId
    ? siteTypeIcons[starterCmsTemplateId]
    : null

  return (
    <aside className={className}>
      <div
        css={theme => ({
          marginRight: theme.space[9],
        })}
      >
        <div
          css={theme => ({
            marginBottom: theme.space[8],
            boxShadow: theme.shadows.raised,
          })}
        >
          <div
            css={{
              backgroundSize: `cover`,
              backgroundImage: `url(${starterImageUrl})`, // left these styles inline to allow image to be passed in
              width: `100%`,
              paddingTop: `56.25%`, // approach to maintain the aspect ratio
              height: `0px`,
            }}
          />
          <div css={cardInfoCss}>
            <Text
              css={{
                fontSize: "12px",
                width: "100%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                textAlign: "left",
              }}
              tone="NEUTRAL"
              variant="EMPHASIZED"
              noMarginBottom
            >
              {starterTitle}
            </Text>
            {Icon ? Icon : null}
          </div>
        </div>
      </div>
      <Stepper currentStep={currentStep}>
        {stepLabels.map(text => (
          <Step key={text} text={text} />
        ))}
      </Stepper>
    </aside>
  )
}
